declare interface ArrayConstructor {
    fillFromTo(start: number, to: number): Array<number>;
}

Array.fillFromTo = (start, to): Array<number> => {
    if (start > to) {
        throw Error('Start number is higher than end number.');
    }

    const result = [];

    for (let i = start; i <= to; i++) {
        result.push(i);
    }
    return result;
};
